export default function Numpy_CreatingArrays() {
  return <div>Numpy_CreatingArrays Component</div>;
}
